import React from "react";

export default function Plus({ color = "#424242", ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={22}
      viewBox="0 0 22 22"
      {...restProps}
    >
      <path
        fill={color}
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="square"
        strokeWidth="0"
        d="M11.925 10.075H21v1.85H11.925V21h-1.85V11.925H1v-1.85H10.075V1h1.85V10.075z"
      />
    </svg>
  );
}
